(function() {
  // Reveal al entrar en viewport
  const revealEls = document.querySelectorAll(".reveal, [data-reveal]");
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add("is-in");
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  revealEls.forEach(el => io.observe(el));

  // Parallax suave
  const pxEls = Array.from(document.querySelectorAll("[data-parallax]"));
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        const y = window.scrollY || 0;
        pxEls.forEach(el => {
          const speed = parseFloat(el.getAttribute("data-parallax")) || 0.15;
          el.style.transform = `translate3d(0, ${Math.round(y * speed)}px, 0)`;
        });
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
})();
